/**
 * Blovo Chatwoot bridge — custom events + delegated triggers for contact sections.
 *
 * Trigger options:
 * - Click: [data-action="open-chatwoot"], [data-blovo-chatwoot], a[href="#chat"], a[href="#chatwoot"]
 * - Event: document.dispatchEvent(new CustomEvent('blovo:chatwoot:open', { detail: { ... } }))
 * - API:   window.openBlovoChat({ category, subCategory, source })
 */
(function () {
  if (window.__blovoContactSupportInit) return;
  window.__blovoContactSupportInit = true;

  var TRIGGER_SELECTOR =
    '[data-action="open-chatwoot"], [data-blovo-chatwoot], a[href="#chat"], a[href="#chatwoot"]';
  var pendingDetail = null;

  function readTriggerContext(trigger) {
    if (!trigger) return {};
    var scope = trigger.closest('[data-faq-category]') || trigger.closest('.contact-secondary-wrap');
    return {
      category: trigger.dataset.chatCategory || (scope && scope.dataset.faqCategory) || '',
      subCategory: trigger.dataset.chatSubCategory || '',
      source: trigger.dataset.chatSource || 'help-center'
    };
  }

  function mergeDetail(options, trigger) {
    var fromTrigger = readTriggerContext(trigger);
    options = options || {};
    return {
      category: options.category != null ? options.category : fromTrigger.category,
      subCategory: options.subCategory != null ? options.subCategory : fromTrigger.subCategory,
      source: options.source || fromTrigger.source || 'help-center'
    };
  }

  function applyCustomAttributes(detail) {
    if (!window.$chatwoot || typeof window.$chatwoot.setCustomAttributes !== 'function') return;
    window.$chatwoot.setCustomAttributes({
      faq_category: detail.category || '',
      faq_sub_category: detail.subCategory || '',
      contact_source: detail.source || 'help-center'
    });
  }

  function openChatwootWidget() {
    if (!window.$chatwoot) return false;

    if (typeof window.$chatwoot.toggle === 'function') {
      window.$chatwoot.toggle('open');
      return true;
    }

    if (typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
      window.$chatwoot.toggleBubbleVisibility('show');
      return true;
    }

    return false;
  }

  function runOpen(detail) {
    applyCustomAttributes(detail);
    return openChatwootWidget();
  }

  function openBlovoChat(options, trigger) {
    var detail = mergeDetail(options, trigger);

    if (window.$chatwoot) {
      runOpen(detail);
      return;
    }

    pendingDetail = detail;
    window.addEventListener(
      'chatwoot:ready',
      function onReady() {
        if (!pendingDetail) return;
        var queued = pendingDetail;
        pendingDetail = null;
        runOpen(queued);
      },
      { once: true }
    );
  }

  function dispatchOpen(detail) {
    document.dispatchEvent(
      new CustomEvent('blovo:chatwoot:open', {
        bubbles: true,
        cancelable: true,
        detail: detail || {}
      })
    );
  }

  document.addEventListener('blovo:chatwoot:open', function (event) {
    if (event.defaultPrevented) return;
    openBlovoChat(event.detail || {}, event.target instanceof Element ? event.target : null);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    openBlovoChat({}, trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    openBlovoChat({}, trigger);
  });

  window.openBlovoChat = function (options) {
    openBlovoChat(options, null);
  };

  window.BlovoContactSupport = {
    open: openBlovoChat,
    dispatch: dispatchOpen
  };
})();
